import React, { useState, useEffect, useRef, useContext } from "react";
import MyContext from "../context/MyContext";
import AuthContext from "../context/userAuth.context";
import axios from "axios";
import GetDur from "../editor.component/bottom.component/timline/getdur";
import TTS from "./TTS";
function TTSSettings(props) {
  const containerRef = useRef();
  const [position, setposition] = useState({
    y: 0,
    x: 0,
  });
  const [UploadData, setUploadData] = useState(null);
  const { authenticationData } = useContext(AuthContext);
  const [ttsaudios, setTtsaudios] = useState([]);
  const [currentData, setcurrentData] = useState({
    key: null,
    point: null,
    activeTransition: "none",
  });
  const { calculateWidthByDuration, calculateTimeByWidth, onePxEquivalent } =
    useContext(MyContext);
  const [ShowTTS, setShowTTS] = useState(false);

  const getaudios = () => {
    let authData = JSON.parse(
      localStorage.getItem("animation_studio_2.0_access_token")
    );

    axios
      .get(authenticationData.ApiBaseURL + "/api/Character/GetSounds", {
        headers: {
          "Content-Type": `multipart/form-data`,
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + authData.access_token,
        },
      })
      .then((response) => {
        response.data.userSounds.map((value) => {
          value.isPlay = true;
          value.Audio = null;
        });

        setTtsaudios(response.data.userSounds);

        // console.log("usr sounds");
        // console.log(response.data.userSounds);
      });
  };

  useEffect(() => {
    getaudios();
  }, []);

  const { setLayersData, LayersData, EditorZoom, myarr } =
    useContext(MyContext);

  // useEffect(() => {

  //   // debugger
  //   containerRef.current.focus();
  //   if (parseInt(props.values.y) < 0 && parseInt(props.values.x) > 0) {
  //     setposition({ x: (props.values.x * EditorZoom) / 100, y: 0 });
  //   }
  //   else if (parseInt(props.values.x) < 0 && parseInt(props.values.y) > 0) {
  //     if (parseInt(props.values.y) + containerRef.current.offsetHeight >= parseInt(props.parentHeight)) {
  //       setposition({ x: (props.values.x + props.values.width + 155), y: parseInt(props.parentHeight) - containerRef.current.offsetHeight });
  //     }
  //     else {
  //       setposition({ x: (props.values.x + props.values.width + 155), y: (props.values.y * EditorZoom) / 100 });
  //     }
  //   }
  //   else if (parseInt(props.values.x) < 0 && parseInt(props.values.y) < 0) {
  //     setposition({ x: (props.values.x + props.values.width + 155), y: 0 });
  //   }
  //   else if (parseInt(props.values.x) > 0 && parseInt(props.values.y) > 0) {

  //     let subtractedHeight = parseInt(props.parentHeight) - parseInt((props.values.y * EditorZoom) / 100);
  //     if (parseInt(props.parentHeight) - subtractedHeight + containerRef.current.offsetHeight >= parseInt(props.parentHeight)) {
  //       setposition({ x: (props.values.x * EditorZoom) / 100, y: parseInt(props.parentHeight) - containerRef.current.offsetHeight });
  //     } else {
  //       setposition({ x: (props.values.x * EditorZoom) / 100, y: (props.values.y * EditorZoom) / 100 });
  //     }
  //   }
  // }, [containerRef]);

  const out = (e) => {
    if (
      props.SliderShow !== true &&
      props.colorShow !== true &&
      props.StrokeShow !== true &&
      (!e.relatedTarget ||
        e.relatedTarget.hasAttribute("contenteditable") != true) &&
      e.relatedTarget &&
      e.relatedTarget.className &&
      e.relatedTarget.className != "boxBottom font-setter"
    ) {
      var index = LayersData.findIndex((x) => x.key === props.values.key);
      LayersData[index].isTTS = false;
      setLayersData(LayersData);
    }
  };
  return (
    <div
      tabIndex="1"
      onBlur={out}
      ref={containerRef}
      style={{
        zIndex: 4000,
        position: "absolute",
        // left: position.x + 365,
        left: position.x + 345,
        top: position.y,
        // x:position.x,
        // y:position.y,
        width: "30%",
      }}
    >
      <div key={props.keys} className="Sound_Box">
        <div className="Setting_Box p-3">
          <div style={{ width: "100%" }}>
            <h5> Text to Speech Settings</h5>

            <div style={{ width: "100%", padding: "5px" }}>
              <button
                style={{ width: "100%" }}
                onClick={() => {
                  setShowTTS(true);
                }}
              >
                {" "}
                Add TTS{" "}
              </button>

              {ttsaudios.map((value, index) => (
                <GetDur
                  key={"FreeSounds" + index}
                  ttsaudios={ttsaudios}
                  setTtsaudios={setTtsaudios}
                  isTTS={props.isTTS}
                  setIsTTS={props.setIsTTS}
                  values={props.values}
                  value={value}
                  UploadData={UploadData}
                  setUploadData={setUploadData}
                  LayersData={props.LayersData}
                  setLayersData={props.setLayersData}
                  authenticationData={authenticationData}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <TTS show={ShowTTS} onHide={setShowTTS} />
    </div>
  );
}

export default TTSSettings;
